export default {
  "$component-active-bg": "Selected/Active Component Color",
};
